import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { ShapeElement } from "../Components/Elements/Graphics/ShapeElement";

@engineComponent(ComponentTypes.DisplayObject)
export class PolygonElement extends ShapeElement {
    private _points: Array<PIXI.Point>;

    constructor() {
        super();
    }

    public updateByNode(node: Element): boolean {
        let redraw: boolean = false;

        if (node.hasAttribute(PolygonElementAttributes.POINTS)) {
            let pointArray: Array<string> = node.getAttribute(PolygonElementAttributes.POINTS).split(";");
            this._points = [];
            let lastPoint: PIXI.Point;
            pointArray.forEach((value: string, index: number) => {
                if (index % 2) {
                    lastPoint.y = parseInt(value);
                } else {
                    lastPoint = new PIXI.Point(parseInt(value), 0);
                    this._points.push(lastPoint);
                }
            });

            redraw = true;
        }

        if (!super.updateByNode(node)) {
            if (redraw) {
                this.redraw();
                return true;
            } else {
                return false;
            }
        }
        return true;
    }

    public redraw(): void {
        this.clear();
        this.beginFill(this._color, this._fillAlpha);
        this.lineStyle(this._lineWidth, this._lineColor, this._lineAlpha);
        this.drawPolygon(this._points);
        this.endFill();
    }

    clone(): ShapeElement {
        let element: PolygonElement = new PolygonElement();
        element.removeChildren();

        element.position.x = this.position.x;
        element.position.y = this.position.y;
        element.pivot.x = this.pivot.x;
        element.pivot.y = this.pivot.y;
        element.scale.x = this.scale.x;
        element.scale.y = this.scale.y;
        element.rotation = this.rotation;
        element.visible = this.visible;
        element.alpha = this.alpha;
        element.tint = this.tint;
        element.blendMode = this.blendMode;
        element.name = this.name;
        element._tweenEngine = this._tweenEngine;

        element._lineWidth = this._lineWidth;
        element._lineColor = this._lineColor;
        element._lineAlpha = this._lineAlpha;
        element._fillAlpha = this._fillAlpha;
        element._color = this._color;
        element._points = [];
        this._points.forEach((point) => {
            element._points.push(new PIXI.Point(point.x, point.y));
        });

        element.redraw();

        return element;
    }
}

export const PolygonElementAttributes = {
    /*
     * Array of semicolon-separated X;Y coordinates, e.g. "0;10;20;10;30;30"
     */
    POINTS: "Points",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/PolygonElement.ts
 **/